import { Suspense } from "react"
import { useTranslation } from "react-i18next"
import { Link, useParams } from "react-router"
import { useGetOpexSelectedCategories } from "../api"
import { PeriodType } from "@/types"
import { badgeStatusVariants } from "@/feature/financial-model/constants"
import { Skeleton } from "@/components/ui/skeleton"
import { SupportedLanguage } from "@/i18n/constants"
import {
  SetUpCard,
  SetUpCardBadge,
  SetUpCardBody,
  SetUpCardContent,
  SetUpCardDescription,
  SetUpCardHeader,
  SetupCardIcon,
  SetUpCardTitle,
} from "@/components/shared/SetupCard"

const FALLBACK_DESCRIPTION = `Lorem ipsum dolor sit amet consectetur. Adipiscing elit sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.`

export const OpexCategoryCardLinks = (props: { period: PeriodType }) => {
  const { period } = props
  const { id: financialModelId } = useParams<{ id: string }>()
  if (!financialModelId)
    throw new Error(
      `OpexCategoryCardLinks > Financial model id is not defined in the url`
    )
  const { data: categories } = useGetOpexSelectedCategories({
    financialModelId,
  })
  const { t: commonT, i18n } = useTranslation(`common`)
  return (
    <div className="grid grid-cols-3 gap-4">
      {categories.map((category) => (
        <Link
          key={category.opex_category.id}
          className="w-full"
          to={`/dashboard/financial-model/${financialModelId}/ecommerce/opex/${period}/${category.opex_category.id}`}
        >
          <SetUpCard>
            <SetUpCardContent>
              <SetUpCardBody>
                <SetUpCardHeader>
                  <SetUpCardTitle>{category.opex_category.name}</SetUpCardTitle>
                  <SetUpCardDescription>
                    {category.opex_category.description?.[
                      i18n.language as SupportedLanguage
                    ] ?? FALLBACK_DESCRIPTION}
                  </SetUpCardDescription>
                </SetUpCardHeader>
                <Suspense
                  fallback={<Skeleton className="w-20 h-7 mt-4 rounded-full" />}
                >
                  <SetUpCardBadge
                    variant={
                      badgeStatusVariants[
                        category.status[props.period] ?? `not_started`
                      ]
                    }
                  >
                    {commonT(
                      `bedges.${category.status[props.period] ?? `not_started`}`
                    )}
                  </SetUpCardBadge>
                </Suspense>
              </SetUpCardBody>
              <SetupCardIcon />
            </SetUpCardContent>
          </SetUpCard>
        </Link>
      ))}
    </div>
  )
}
